import React, { useState, useEffect } from 'react';
import NavLinks from './NavLinks';
import { HashLink } from 'react-router-hash-link';
import logo from './Saving-Strides-logo.png';

const NavBar = () => {
    const [top, setTop] = useState(!window.scrollY);
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => { document.body.style.overflow = ''; };
    }, [isOpen]);

    useEffect(() => {
        const scrollHandler = () => {
            window.pageYOffset > 10 ? setTop(false) : setTop(true);
        };
        window.addEventListener('scroll', scrollHandler);
        return () => window.removeEventListener('scroll', scrollHandler);
    }, [top]);

    return (
        <>
            <nav className={`fixed top-0 w-full z-30 transition duration-300 ease-in-out ${!top ? 'bg-white shadow-lg' : ''}`}>
                <div className="flex flex-row justify-between items-center py-3">
                    <div className="flex flex-row items-center pl-4 md:pl-8">
                        <HashLink smooth to="/#hero" onClick={closeMenu}>
                            <img
                                src={logo}
                                alt="Saving Strides Logo"
                                className="h-10 w-auto object-contain md:h-14"
                                style={{ maxWidth: '150px' }}
                            />
                        </HashLink>
                    </div>

                    {/* Desktop nav */}
                    <div className="hidden lg:flex items-center space-x-6 pr-8">
                        <NavLinks isTransparent={top} isMobileMenuOpen={false} />
                    </div>

                    {/* Animated burger button */}
                    <button
                        className={`lg:hidden p-3 mr-2 rounded-xl transition-all duration-200 ${
                            top ? 'text-white hover:bg-white/10' : 'text-black hover:bg-gray-100'
                        }`}
                        onClick={handleClick}
                        aria-label={isOpen ? 'Close menu' : 'Open menu'}
                        aria-expanded={isOpen}
                    >
                        <div className="w-6 h-5 flex flex-col justify-between relative">
                            <span
                                className={`block h-0.5 w-full bg-current rounded-full origin-center transition-all duration-300 ease-in-out ${
                                    isOpen ? 'rotate-45 translate-y-[9px]' : ''
                                }`}
                            />
                            <span
                                className={`block h-0.5 bg-current rounded-full transition-all duration-200 ease-in-out ${
                                    isOpen ? 'w-0 opacity-0' : 'w-full opacity-100'
                                }`}
                            />
                            <span
                                className={`block h-0.5 w-full bg-current rounded-full origin-center transition-all duration-300 ease-in-out ${
                                    isOpen ? '-rotate-45 -translate-y-[9px]' : ''
                                }`}
                            />
                        </div>
                    </button>
                </div>
            </nav>

            {/* Backdrop overlay */}
            <div
                className={`fixed inset-0 z-40 bg-black/40 backdrop-blur-sm lg:hidden transition-opacity duration-300 ${
                    isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                }`}
                onClick={closeMenu}
                aria-hidden="true"
            />

            {/* Slide-in drawer */}
            <div
                className={`fixed top-0 right-0 h-full w-4/5 max-w-xs z-50 bg-white lg:hidden flex flex-col shadow-2xl transition-transform duration-300 ease-in-out ${
                    isOpen ? 'translate-x-0' : 'translate-x-full'
                }`}
                role="dialog"
                aria-modal="true"
                aria-label="Mobile navigation"
            >
                {/* Drawer header */}
                <div className="flex items-center justify-between px-6 pt-6 pb-4 border-b border-gray-100">
                    <span className="font-bold text-xl tracking-tight" style={{ fontFamily: "'Syne', sans-serif" }}>
                        Menu
                    </span>
                    <button
                        onClick={closeMenu}
                        className="p-2 rounded-xl text-gray-400 hover:text-black hover:bg-gray-100 transition-all duration-150"
                        aria-label="Close menu"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                {/* Staggered nav links */}
                <nav className="flex flex-col px-4 py-6 flex-grow overflow-y-auto">
                    <NavLinks isTransparent={false} isMobileMenuOpen={isOpen} onLinkClick={closeMenu} />
                </nav>

                {/* Drawer footer */}
                <div className="px-6 py-5 border-t border-gray-100">
                    <p className="text-xs text-gray-400 text-center">
                        © {new Date().getFullYear()} Saving Strides
                    </p>
                </div>
            </div>
        </>
    );
};

export default NavBar;
